<template>
  <footer
    id="footer"
    :class="isLightTheme ? 'footer-light' : 'footer bg-brand-highlight-3'"
  >
    <div v-if="!isLightTheme">
      <ul v-if="socialMediaLinks" class="social-media-links">
        <li v-for="(item, key) in socialMediaLinks.links" :key="key">
          <a
            :href="item.url"
            :target="socialMediaLinks.opensInNewTab ? '_blank' : '_self'"
          >
            <img
              :class="
                item.label.toLowerCase() === 'bcorp'
                  ? 'bcorp-img'
                  : 'social-media-img'
              "
              :src="`/img/footer/${item.label.toLowerCase()}.svg`"
              :alt="item.label"
            />
          </a>
        </li>
      </ul>
      <div class="footer-nav">
        <span>© Simplyhealth {{ currentYear }}. All rights reserved.</span>
        <ul v-if="navigationLinks" class="footer-nav-links">
          <li
            class="footer-nav-link"
            v-for="(item, key) in navigationLinks.links"
            :key="key"
          >
            <a
              :href="item.url"
              :target="navigationLinks.opensInNewTab ? '_blank' : '_self'"
            >
              {{ item.label }}
            </a>
          </li>
        </ul>
      </div>
    </div>
    <div class="d-flex justify-content-center align-items-center" v-else>
      <p class="powered-by">
        Powered by
        <img
          src="/img/footer/spectrum-life-logo.png"
          alt="Spectrum.Life logo"
          class="spectrum-life-logo"
        />
      </p>
    </div>
  </footer>
</template>

<script>
import { mapState } from "vuex";

export default {
  name: "Footer",
  props: {
    isLightTheme: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    ...mapState(["navigationTags"]),
    socialMediaLinks() {
      return this.navigationTags?.footerSocialMedia || null;
    },
    navigationLinks() {
      return this.navigationTags?.footerLinks || null;
    },
    currentYear() {
      const today = new Date();
      let year = today.getFullYear();
      return year
    }
  }
};
</script>

<style lang="less">
.powered-by {
  font-family: "PlusJakartaSansRegular";
}

.footer {
  padding: 16px 24px;
  border-top-left-radius: 24px;
  border-top-right-radius: 24px;
  max-width: 1170px;
  width: 100%;
  margin: 0 auto;

  .footer-nav {
    display: flex;
    justify-content: space-between;
    color: #fff;
    font-size: 1.6rem;
    gap: 10px;
  }

  .bcorp-img {
    width: 54px;
    height: 80px;
    object-fit: contain;
  }

  .social-media-links {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 20px;
    margin-bottom: 8px;
  }

  .social-media-img {
    height: 24px;
    object-fit: contain;
  }

  .footer-nav-links {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    align-items: center;
    gap: 18px;
  }

  .footer-nav-link {
    border-bottom: 1px solid #fff;
  }

  ul {
    margin: 0;
    padding: 0;
  }

  li {
    list-style: none outside none;
  }

  a {
    color: #fff;
    line-height: 2rem;
    font-size: 1.6rem;

    &:hover {
      color: #fff;
    }
  }
}

.footer-light {
  color: #797b89;
  font-size: 1.4rem;
  padding: 28px;
  text-align: center;
}

.spectrum-life-logo {
  width: 94px;
}

@media screen and (max-width: 991px) {
  .footer {
    .footer-nav {
      flex-direction: column-reverse;
      gap: 20px;
      align-items: center;
      justify-content: center;
    }

    .social-media-links {
      justify-content: center;
      align-items: center;
      gap: 20px;
    }
  }
}
</style>
